import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import SeatMapTraveler from '../components/SeatMapTraveler';
import { jsx as _jsx } from "react/jsx-runtime";
const mapPropsToProps = props => props;
const SeatMapTravelerComponent = props => /*#__PURE__*/_jsx(SeatMapTraveler, {
  ...mapPropsToProps(props)
});
const SeatMapTravelerField = _ref => {
  let {
    fieldName,
    name,
    onChange,
    validate,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(Field, {
    component: SeatMapTravelerComponent,
    name: fieldName,
    props: {
      ...props,
      name,
      onChange
    },
    validate: validate
  });
};
SeatMapTravelerField.propTypes = {
  fieldName: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  validate: PropTypes.func
};
export default SeatMapTravelerField;